import React from "react";
import { FaEnvelope, FaTimesCircle, FaCheckCircle } from "react-icons/fa";
import UserInfoCard from "./UserInfoCard";

export default function ConfirmNotificationModal({
  senderUser,
  receiverUser,
  onClose,
  onConfirm,
  sending,
}) {
  if (!senderUser || !receiverUser) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-3 sm:p-4 overflow-y-auto">
      <div className="bg-white rounded-xl sm:rounded-2xl shadow-2xl max-w-4xl w-full max-h-[95vh] sm:max-h-[90vh] overflow-y-auto overflow-x-hidden my-4 min-w-0">
        {/* Modal Header */}
        <div className="bg-gradient-to-r from-red-500 to-red-600 text-white p-4 sm:p-5 md:p-6 rounded-t-xl sm:rounded-t-2xl">
          <div className="flex items-center justify-between gap-2">
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold flex items-center gap-2 min-w-0">
              <FaEnvelope className="text-base sm:text-lg md:text-xl flex-shrink-0" />
              <span className="text-sm sm:text-base md:text-lg truncate">
                Confirm Notification
              </span>
            </h2>
            <button
              type="button"
              onClick={onClose}
              className="p-2 text-white hover:text-gray-200 transition rounded-full hover:bg-white/10 flex-shrink-0"
              aria-label="Close">
              <FaTimesCircle className="text-xl sm:text-2xl" />
            </button>
          </div>
          <p className="mt-2 text-xs sm:text-sm text-red-100">
            Review the details before sending the notification
          </p>
        </div>

        {/* Modal Body */}
        <div className="p-4 sm:p-5 md:p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 md:gap-6 mb-4 sm:mb-5 md:mb-6">
            <div className="min-w-0">
              <h3 className="text-base sm:text-lg font-bold text-red-600 mb-2 sm:mb-3 border-b-2 border-red-200 pb-1.5 sm:pb-2">
                Sender User
              </h3>
              <UserInfoCard user={senderUser} title="" type="sender" compact />
            </div>
            <div className="min-w-0">
              <h3 className="text-base sm:text-lg font-bold text-red-600 mb-2 sm:mb-3 border-b-2 border-red-200 pb-1.5 sm:pb-2">
                Receiver User
              </h3>
              <UserInfoCard user={receiverUser} title="" type="receiver" compact />
            </div>
          </div>

          <div className="bg-red-50 border-2 border-red-200 rounded-lg sm:rounded-xl p-3 sm:p-4 mb-4 sm:mb-5 md:mb-6">
            <h4 className="font-bold text-sm sm:text-base text-red-800 mb-2">
              Notification Details:
            </h4>
            <p className="text-xs sm:text-sm text-gray-700 break-words">
              <strong>Title:</strong>{" "}
              {`Congrats! ${senderUser.firstName || ""} ${senderUser.lastName || ""} found you compatible! Let's chat!`}
            </p>
            <p className="text-xs sm:text-sm text-gray-700 mt-1 break-words">
              <strong>Message:</strong>{" "}
              {`It seems like ${senderUser.firstName || ""} ${senderUser.lastName || ""} found you compatible! Let's chat!`}
            </p>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="bg-gray-50 p-4 sm:p-5 md:p-6 rounded-b-xl sm:rounded-b-2xl flex flex-col sm:flex-row justify-end gap-3 sm:gap-4 border-t-2 border-red-200">
          <button
            type="button"
            onClick={onClose}
            className="w-full sm:w-auto px-5 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base bg-gray-500 text-white rounded-lg sm:rounded-xl font-semibold hover:bg-gray-600 transition">
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={sending}
            className={`w-full sm:w-auto px-6 sm:px-8 py-2.5 sm:py-3 text-sm sm:text-base bg-gradient-to-r from-red-500 to-red-600 text-white rounded-lg sm:rounded-xl font-bold shadow-lg transition-all flex items-center justify-center gap-2 ${
              sending ? "opacity-50 cursor-not-allowed" : "hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]"
            }`}>
            {sending ? (
              <>
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                Sending...
              </>
            ) : (
              <>
                <FaCheckCircle /> Confirm & Send
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
